<script>
    import { env } from '../../Environment.svelte';
    import { goBack, store, triggerValidation } from '../../Store.svelte';
    import { getBase64 } from '../../Util.svelte';

    import { loadCustomScript } from '@paypal/paypal-js';
    import { onDestroy, onMount } from 'svelte';
    import { navigate } from 'svelte-routing';
    import { fetchAttachFile } from '../../clients/CambaceoClient.svelte';
    import {
        fetchPaymentStatus,
        fetchPaymentURL,
        fetchPayPalPaymentScript,
        getPayPalChannel,
        getPayPalPlatform,
        getPayPalURLCancelOrder,
        getPayPalURLCaptureOrder,
        getPayPalURLCreateOrder,
        updateRecurrentPayment,
    } from '../../clients/PaymentClient.svelte';
    import {
        sendPaymentUrl,
        validatePaymentComplete,
    } from '../../clients/CardPaymentClient.svelte';
    import {
        clientPurchaseFinalize,
        clientPurchaseProcess,
    } from '../../clients/PurchaseClient.svelte';
    import Modal from '../../components/Modal.svelte';
    import Preloader from '../../components/Preloader.svelte';

    let interval;
    let overridePayment =
        $store.purchaseStatus.rptEliminaPagoAnticipado != null
            ? $store.purchaseStatus.rptEliminaPagoAnticipado
            : false;
    let shouldShowPaypalPayment = !$store.requestedServices.isSpMovil;
    let shouldShowVendorPayment = !$store.requestedServices.isSpMovil;
    let shouldShowCashPayment = !$store.requestedServices.isSpMovil;
    let shouldShowContinueWithoutDomicile = $store.requestedServices.isSpMovil;
    let shouldBeDisabled = $store.requestedServices.isSpMovil;
    let isMessageSent = false;
    let cardPaymentError = '';

    let paymentError = '';
    let windowOpen;
    function valContent() {
        loading = true;
        $store.purchaseStatus.status =
            'Tu pago está siendo procesado. Esto solo tomará unos momentos.';
        if ($store.purchaseStatus.paymentType == 'PAYPAL') {
            fetchPaymentStatus($store).then((response) => {
                if (response.izziError != 'Success') {
                    loading = false;
                    paymentError = response.izziError;
                } else {
                    if ($store.purchaseStatus.paymentType == 'ONLINE_SAVED') {
                        updateRecurrentPayment($store);
                    }
                    if (
                        $store.purchaseStatus.paypalBillingAgreement == null ||
                        $store.purchaseStatus.paypalCompleteAgreement
                    ) {
                        finishPurchase();
                    } else {
                        loading = true;
                        windowOpen = window.open(
                            $store.purchaseStatus.paypalBillingAgreement
                                .links[0].href,
                            '_blank'
                        );
                    }
                }
            });
        } else if ($store.purchaseStatus.paymentType === 'ONLINE') {
            validatePaymentCompleteHandler();
        } else {
            finishPurchase();
        }
    }

    let customAction;
    $: messageInfoError = 'Error interno';
    function finishPurchase() {
        if (!$store.purchaseStatus.finalizing) {
            clientPurchaseFinalize($store)
                .then((response) => {
                    if (
                        response != null &&
                        response.code != null &&
                        response.message.length > 0
                    ) {
                        messageInfoError = response.message;
                        $store.purchaseStatus.finalizing = false;
                        loading = false;
                        customAction = () => {};
                        if (
                            response.message.indexOf(
                                'La Fecha en TOA ya fué utilizada, vuelve a capturar fecha'
                            ) > 0
                        ) {
                            messageInfoError =
                                'El horario de instalación seleccionado ya no está disponible, por favor selecciona una fecha o un horario diferente';
                            customAction = () => {
                                navigate('/compra/fecha', { replace: false });
                            };
                        }
                        MicroModal.show('modalError');
                    } else {
                        $store.purchaseStatus.finalizing = true;
                        checkPurchase();
                    }
                })
                .catch((error) => {
                    console.log('ERROR!');
                    console.log(error);
                    messageInfoError = '409 - error';
                    $store.purchaseStatus.finalizing = false;
                    loading = false;
                    MicroModal.show('modalError');
                });
        } else {
            if (!$store.purchaseStatus.finalized) {
                checkPurchase();
            } else {
                navigate('/compra/bienvenido', { replace: false });
            }
        }
    }

    function checkPurchase() {
        var attempts = 0;
        interval = setInterval(() => {
            try {
                clientPurchaseProcess($store.purchaseStatus.processId).then(
                    (response) => {
                        if (response.statusCode == 0) {
                            $store.purchaseStatus.error = response.status;
                        }
                        $store.purchaseStatus.status = response.lastAction;
                        if (
                            response.lastAction == 'Orden programada' ||
                            response.status == 'Finalizada'
                        ) {
                            $store.purchaseStatus.finalized = true;
                            $store.purchaseStatus.finalizedDate = new Date();
                            clearInterval(interval);
                            navigate('/compra/bienvenido', { replace: false });
                        }
                    }
                );
            } catch (err) {
                console.log(err);
            }
            attempts += 1;
            if (attempts > 100) {
                console.log('enough attempts');
                clearInterval(interval);
            }
        }, 10000);
    }

    onMount(() => {
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            })
        );
        $store.settings.location = { progress: 90, step: 5 };
    });

    onDestroy(() => clearInterval(interval));
    // Payment stuff
    let monthlyPayment =
        $store.purchaseStatus.paymentType.indexOf('ONLINE_SAVED') >= 0 ||
        $store.requestedServices.isSpMovil;
    let monthlyPaymentPaypal =
        $store.purchaseStatus.paymentType.indexOf('PAYPAL') >= 0 ||
        $store.requestedServices.isSpMovil;
    let monthlyPaymentAmount = 50;
    $: selectPayment = (paymentType, shouldFinishContracting = false) => {
        $store.purchaseStatus.paymentType = paymentType;
        monthlyPayment = $store.requestedServices.isSpMovil ? true : false;
        $store.requestedServices.total = parseFloat(
            $store.requestedServices.totalOriginal
        );
        // buttonDisabled =
        //     $store.purchaseStatus.paymentType.indexOf('VENDOR') >= 0 &&
        //     $store.purchaseStatus.fileUploaded == null;
        if (paymentType === 'IZZI_CHANNELS' && shouldFinishContracting) {
            console.log('Trigger finish contract');
            // valContent();
        }
    };

    let makeMonthlyPayment = () => {
        $store.requestedServices.total = parseFloat(
            $store.requestedServices.totalOriginal
        );
        if (monthlyPayment) {
            if (overridePayment) {
                $store.requestedServices.total = parseFloat(
                    $store.purchaseStatus.installationExpress ? 100 : 1
                );
            } else {
                if (!$store.requestedServices.isSpMovil)
                    $store.requestedServices.total -= monthlyPaymentAmount;
            }
            loadPayment();
            $store.purchaseStatus.paymentType = 'ONLINE_SAVED';
        } else {
            loadPayment();
            $store.purchaseStatus.paymentType = 'ONLINE';
        }
    };

    let makeMonthlyPaymentPaypal = () => {
        $store.requestedServices.total = parseFloat(
            $store.requestedServices.totalOriginal
        );
        if (monthlyPaymentPaypal) {
            if (overridePayment) {
                $store.requestedServices.total = parseFloat(
                    $store.purchaseStatus.installationExpress ? 100 : 1
                );
            } else {
                $store.requestedServices.total -= monthlyPaymentAmount;
            }
        }
        $store.purchaseStatus.paymentType = 'PAYPAL';
    };

    $: paymentURL = $store.purchaseStatus.paymentURL;
    let fetchingPayment;
    let loadPayment = () => {
        paymentURL = '';
        fetchingPayment = fetchPaymentURL($store).then((response) => {
            if (response.response != null && response.response.html != null) {
                paymentURL = response.response.html;
                $store.purchaseStatus.paymentURL = response.response.html;
                $store.purchaseStatus.paymentReference =
                    response.response.reference;
            }
        });
    };
    if ($store.purchaseStatus.paymentURL == null) {
        loadPayment();
    }

    $: paymentPayPalScriptURL = $store.purchaseStatus.paypalPaymentScriptURL;
    $: paypalCreateOrderURL = '';
    $: paypalCaptureOrderURL = '';
    $: paypalCancelOrderURL = '';
    $: paypalChannel = '';
    $: paypalPlatform = '';

    getPayPalURLCreateOrder($store).then((response) => {
        paypalCreateOrderURL = response + $store.purchaseStatus.accountNumber;
    });

    getPayPalURLCaptureOrder($store).then((response) => {
        paypalCaptureOrderURL = response + $store.purchaseStatus.accountNumber;
    });

    getPayPalURLCancelOrder($store).then((response) => {
        paypalCancelOrderURL = response + $store.purchaseStatus.accountNumber;
    });

    getPayPalChannel($store).then((response) => {
        paypalChannel = response;
    });

    getPayPalPlatform($store).then((response) => {
        paypalPlatform = response;
    });

    $: RPTPaypal = '000';
    $: payPalPaymentRef = '';
    let fetchingPaymentPayPal;
    let loadPaymentPaypal = () => {
        fetchingPaymentPayPal = fetchPayPalPaymentScript($store).then(
            (response) => {
                if (response.paypal_url != null) {
                    paymentPayPalScriptURL = response.paypal_url;
                    $store.purchaseStatus.paypalPaymentScriptURL =
                        response.paypal_url;

                    loadCustomScript({
                        url: response.paypal_url,
                        attributes: {},
                    })
                        .then(() => {
                            configuraBotonPayPal();
                        })
                        .catch((err) => {
                            console.error(
                                'Error al cargar el script de PayPal',
                                err
                            );
                        });
                }
            }
        );
    };
    let configuraBotonPayPal = () => {
        if ($store.requestedAddress.addressRPT)
            RPTPaypal = $store.requestedAddress.addressRPT;
        paypal
            .Buttons({
                style: {
                    label: 'pay',
                },
                createOrder: function () {
                    let req = {
                        amount: $store.requestedServices.total,
                    };
                    var headersCreate = new Headers();
                    headersCreate.append('content-type', 'application/json');
                    headersCreate.append('channel', paypalChannel);
                    headersCreate.append('platform', paypalPlatform);
                    headersCreate.append('rpt', RPTPaypal);
                    headersCreate.append('exencion', false);
                    headersCreate.append(
                        'x-api-key',
                        env[env.stage].apiPayPal.key
                    );
                    return fetch(paypalCreateOrderURL, {
                        method: 'POST',
                        headers: headersCreate,
                        body: JSON.stringify(req),
                    })
                        .then(function (res) {
                            return res.json();
                        })
                        .then(function (data) {
                            payPalPaymentRef = data.reference;
                            $store.purchaseStatus.paypalPaymentReference =
                                payPalPaymentRef;
                            return data.order;
                        });
                },
                onApprove: function (data) {
                    data['errorTest'] = false;
                    data['baFlag'] = document.getElementById(
                        'pago_recurrente_paypal'
                    ).checked;
                    var headersCapture = new Headers();
                    headersCapture.append('content-type', 'application/json');
                    headersCapture.append('Accept', 'application/json');
                    headersCapture.append('channel', paypalChannel);
                    headersCapture.append('platform', paypalPlatform);
                    headersCapture.append('rpt', RPTPaypal);
                    headersCapture.append(
                        'x-api-key',
                        env[env.stage].apiPayPal.key
                    );
                    return fetch(paypalCaptureOrderURL, {
                        method: 'POST',
                        headers: headersCapture,
                        body: JSON.stringify(data),
                    })
                        .then(function (res) {
                            return res.json();
                        })
                        .then(function (details) {
                            if (details != null) {
                                $store.purchaseStatus.paypalStatus =
                                    details.status;
                                if (
                                    details.status != null &&
                                    details.status == 'COMPLETED'
                                ) {
                                    $store.purchaseStatus.paypalMessage =
                                        'Tu pago con PayPal fue aprobado con éxito ¡Gracias! Referencia: ' +
                                        payPalPaymentRef +
                                        ' Monto: $' +
                                        $store.requestedServices.total;
                                    if (
                                        document.getElementById(
                                            'pago_recurrente_paypal'
                                        ).checked
                                    ) {
                                        $store.purchaseStatus.paypalBillingAgreement =
                                            details.billingAgreement;
                                    }
                                } else {
                                    $store.purchaseStatus.paypalMessage =
                                        'Ocurrió un error durante la transacción con PayPal. Te sugerimos agregar una nueva tarjeta en tu cuenta PayPal o verificar el estado de tu tarjeta en PayPal.com ';
                                }
                            }
                        });
                },
                onCancel: function (data) {
                    // Show a cancel page, or return to cart

                    var para = document.getElementById('cancel');

                    let req = {
                        orderID: data.orderID,
                    };
                    var headersCancel = new Headers();
                    headersCancel.append('content-type', 'application/json');
                    headersCancel.append('Accept', 'application/json');
                    headersCancel.append('channel', paypalChannel);
                    headersCancel.append('platform', paypalPlatform);
                    headersCancel.append('rpt', RPTPaypal);
                    headersCancel.append(
                        'x-api-key',
                        env[env.stage].apiPayPal.key
                    );
                    fetch(paypalCancelOrderURL, {
                        method: 'POST',
                        headers: headersCancel,
                        body: JSON.stringify(req),
                    })
                        .then(function (res) {
                            return res.json();
                        })
                        .then(function (data) {
                            $store.purchaseStatus.paypalMessage =
                                'Tu solicitud de pago fue cancelada.';
                        });
                },
            })
            .render('#paypal-button-container');
    };

    loadPaymentPaypal();

    $: loading = false;

    $: buttonFinishText =
        $store.purchaseStatus.paypalBillingAgreement == null ||
        $store.purchaseStatus.paypalCompleteAgreement
            ? 'Terminar contratación'
            : 'Acuerdo de pagos';

    if (
        !$store.purchaseStatus.paypalCompleteAgreement &&
        $store.purchaseStatus.paypalBillingAgreement == null
    ) {
        makeMonthlyPayment();
    }

    function functionWait() {
        if (windowOpen.closed) {
            location.reload();
        }
    }

    $: {
        if ($goBack) {
            backRoute();
            goBack.set(false);
        }

        if ($triggerValidation) {
            valContent();
            triggerValidation.set(false);
        }
    }

    function backRoute() {
        navigate('/compra/resumen', { replace: false });
    }

    let isSendingPaymentUrl = false;
    let paymentUrlButtonText = 'Enviar liga de pago';

    const sendPaymentUrlHandler = async () => {
        isSendingPaymentUrl = true;
        cardPaymentError = '';
        try {
            const response = await sendPaymentUrl($store);
            isMessageSent = true;
            $store.purchaseStatus.paymentReference =
                response.response.reference;
            paymentUrlButtonText = 'Reenviar liga de pago';
        } catch {
            MicroModal.show('modalError');
        } finally {
            isSendingPaymentUrl = false;
        }
    };

    const validatePaymentCompleteHandler = async () => {
        validatePaymentComplete($store)
            .then(() => {
                finishPurchase();
            })
            .catch((error) => {
                cardPaymentError = error.details;
                loading = false;
            });
    };
</script>

<div>
    <div class="pure-g justify-content-center {loading ? '' : 'hide'}">
        <div class="pure-u-1">
            <div class="text-center">
                <Preloader
                    status="Tu pago está siendo procesado. Esto solo tomará unos momentos."
                />
            </div>
        </div>
    </div>
    <div
        class="pure-g justify-content-center {!loading ? '' : 'hide'}"
        style="--dynamic-rgba: {$store.requestedServices.isSky
            ? 'rgba(4, 8, 255, 0.342)'
            : 'rgba(211, 23, 114, 0.1)'};
               --dynamic-color: {$store.requestedServices.isSky
            ? '#000ff5'
            : '#d31772'};"
    >
        <div class="pure-u-1 pure-u-md-3-4 pure-u-lg-3-5">
            <div class="payment-tabs">
                <div class="payment-tab-controls__holder">
                    <div
                        class="payment-tab-controls"
                        class:payment-tab-controls-blue={$store
                            .requestedServices.isSky}
                    >
                        <a
                            href="#tab_tarjeta"
                            value="tarjeta"
                            on:click={makeMonthlyPayment}
                            class="payment-tab-control {$store.purchaseStatus.paymentType.indexOf(
                                'ONLINE'
                            ) >= 0
                                ? 'payment-tab-control--active'
                                : ''}"
                            id="pago-tarjeta-ga4"
                        >
                            <span class="hide-for-mobile">Pago en tarjeta</span>
                            <span class="show-for-mobile">Tarjeta</span>
                        </a>
                        {#if shouldShowPaypalPayment}
                            <a
                                href="#tab_paypal"
                                value="paypal"
                                on:click={selectPayment('PAYPAL')}
                                class="payment-tab-control {$store.purchaseStatus.paymentType.indexOf(
                                    'PAYPAL'
                                ) >= 0
                                    ? 'payment-tab-control--active'
                                    : ''}"
                            >
                                <span class="hide-for-mobile"
                                    >Pago con PayPal</span
                                >
                                <span class="show-for-mobile">PayPal</span>
                                <div class="new-tooltip">NUEVO</div>
                            </a>
                        {/if}
                        {#if shouldShowCashPayment}
                            <a
                                href="#tab_efectivo"
                                value="efectivo"
                                on:click={selectPayment('IZZI_CHANNELS')}
                                class="payment-tab-control {$store.purchaseStatus.paymentType.indexOf(
                                    'IZZI_CHANNELS'
                                ) >= 0
                                    ? 'payment-tab-control--active'
                                    : ''}"
                            >
                                <span class="hide-for-mobile"
                                    >Pago en efectivo</span
                                >
                                <span class="show-for-mobile">Efectivo</span>
                            </a>
                        {/if}
                        {#if shouldShowVendorPayment && $store.requestedServices.deliveryType != 'DOMICILIO'}
                            <a
                                href="#tab_sucursal"
                                value="sucursal"
                                on:click={selectPayment('VENDOR')}
                                class="payment-tab-control {$store.purchaseStatus.paymentType.indexOf(
                                    'VENDOR'
                                ) >= 0
                                    ? 'payment-tab-control--active'
                                    : ''}"
                            >
                                <span class="hide-for-mobile"
                                    >{$store.requestedServices.deliveryType ===
                                    'SUCURSAL'
                                        ? 'Sucursal'
                                        : 'Pago al técnico'}</span
                                >
                                <span class="show-for-mobile">
                                    {$store.requestedServices.deliveryType ===
                                    'SUCURSAL'
                                        ? 'Sucursal'
                                        : 'Pago al técnico'}</span
                                >
                            </a>
                        {/if}
                        {#if shouldShowContinueWithoutDomicile}
                            <a
                                href="#tab_sin_domiciliar"
                                value="sin-domiciliar"
                                on:click={selectPayment('IZZI_CHANNELS')}
                                class="payment-tab-control {$store.purchaseStatus.paymentType.indexOf(
                                    'IZZI_CHANNELS'
                                ) >= 0
                                    ? 'payment-tab-control--active'
                                    : ''}"
                            >
                                <span class="white-text hide-for-mobile"
                                    >Continuar sin domiciliar</span
                                >
                                <span class="white-text show-for-mobile"
                                    >Continuar sin domiciliar</span
                                >
                            </a>
                        {/if}
                    </div>
                </div>
            </div>

            <div class="payment-tab__content-holder">
                <div
                    id="tab_tarjeta"
                    class="payment-tab-content payment-tab-content--active {$store.purchaseStatus.paymentType.indexOf(
                        'ONLINE'
                    ) < 0
                        ? 'hide'
                        : ''}"
                >
                    <div class="pure-g">
                        <div class="pure-u-1 pure-u-md-7-12">
                            <p>Tu compra estará protegida en todo momento.</p>
                        </div>
                        <div class="pure-u-1 pure-u-md-5-12 md-text-right">
                            <p
                                class="fw-semibold d-flex align-items-center justify-content-end sm-justify-content-start"
                            >
                                <span>Servidor seguro</span>
                                <svg class="icon m-l-10" aria-hidden="true">
                                    <use
                                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-lock"
                                    />
                                </svg>
                            </p>
                        </div>
                    </div>
                    <div class="panel m-b-40">
                        <p
                            class="primary-text text-center text-fs-20 fw-semibold"
                        >
                            No. Cuenta {$store.purchaseStatus.accountNumber}
                        </p>
                        <p class="m-b-30">
                            Valida tu número de celular y correo electrónico.
                            Recibirás por SMS y correo electrónico una liga con
                            la que podrás domiciliar y realizar realizar tu
                            pago.
                        </p>
                        <div class="pure-g m-b-20">
                            <div
                                class="flex-flow-column pure-u-lg-1-2 pure-u-1 pure-u-lg-offset-1-4"
                            >
                                <div class="ctrl-holder m-b-20">
                                    <label for="numero" class="placeholder"
                                        >Número celular</label
                                    >
                                    <input
                                        type="text"
                                        name="numero"
                                        id="numero"
                                        required
                                        disabled
                                        bind:value={
                                            $store.personalDetails.numeroCelular
                                        }
                                    />
                                </div>
                                <div class="ctrl-holder m-b-20">
                                    <label for="email" class="placeholder"
                                        >Correo electrónico</label
                                    >
                                    <input
                                        type="text"
                                        name="email"
                                        id="email"
                                        required
                                        disabled
                                        bind:value={
                                            $store.personalDetails.correo
                                        }
                                    />
                                </div>
                                <div class="d-flex justify-content-center">
                                    <button
                                        on:click={sendPaymentUrlHandler}
                                        type="button"
                                        class="pure__button continue-button"
                                        disabled={isSendingPaymentUrl}
                                    >
                                        {#if isSendingPaymentUrl}
                                            <span
                                                class="loader"
                                                style="margin-right:8px;"
                                            ></span>
                                        {/if}
                                        {paymentUrlButtonText}
                                    </button>
                                </div>
                            </div>
                        </div>
                        {#if isMessageSent}
                            <p class="primary-text m-b-10">
                                ¡Enlace de pago enviado con éxito!
                            </p>
                            <p class="m-b-10">
                                Si no recibiste el enlace, por favor intenta de
                                nuevo.
                            </p>
                            <p class="m-b-0">
                                Después de realizar tu pago, haz clic en el
                                botón <span class="fw-semibold"
                                    >“Terminar contratación”</span
                                >
                                para finalizar tu compra.
                            </p>
                        {/if}
                    </div>
                    <p>{cardPaymentError}</p>
                </div>
                {#if shouldShowContinueWithoutDomicile}
                    <div
                        id="tab_sin_domiciliar"
                        class="payment-tab-content {$store.purchaseStatus.paymentType.indexOf(
                            'IZZI_CHANNELS'
                        ) < 0
                            ? 'hide'
                            : ''}"
                    >
                        <div class="panel text-center m-b-40">
                            <p class="m-b-25">
                                Tu pago comenzará en tu próximo estado de cuenta
                            </p>
                            <div
                                class="h2 text-fs-26 fw-semibold primary-text m-b-25"
                            >
                                No. Cuenta {$store.purchaseStatus.accountNumber}
                            </div>
                        </div>
                    </div>
                {/if}
                {#if shouldShowCashPayment}
                    <div
                        id="tab_efectivo"
                        class="payment-tab-content {$store.purchaseStatus.paymentType.indexOf(
                            'IZZI_CHANNELS'
                        ) < 0
                            ? 'hide'
                            : ''}"
                    >
                        <div class="panel text-center m-b-40">
                            <p class="m-b-25">
                                Utiliza la línea de captura para realizar el
                                pago en efectivo en cualquiera de estos
                                establecimientos.
                            </p>
                            <div class="payment-stores centered m-b-25">
                                <img
                                    class="oxxo-logo"
                                    src="/assets/img/dummy-img/logos/oxxo-logo@2x.png"
                                    alt="Oxxo"
                                />
                                <img
                                    class="seven-logo"
                                    src="/assets/img/dummy-img/logos/seven-eleven-logo@2x.png"
                                    alt="Seven Eleven"
                                />
                                <img
                                    class="aurrera-logo"
                                    src="/assets/img/dummy-img/logos/bodega-aurrera@2x.png"
                                    alt="Bodega Aurrera"
                                />
                            </div>
                            <div
                                class="h2 text-fs-26 fw-semibold primary-text m-b-25"
                                class:blue-dark-text={$store.requestedServices
                                    .isSky}
                            >
                                No. Cuenta {$store.purchaseStatus.accountNumber}
                            </div>
                            <p class="m-b-0">
                                Presenta este código, tienes 2 días para
                                realizar el pago. Una vez realizado tu pago te
                                llamaremos para confirmar tu visita
                            </p>
                        </div>
                    </div>
                {/if}
                {#if shouldShowVendorPayment}
                    <div
                        id="tab_tecnico"
                        class="payment-tab-content {$store.purchaseStatus.paymentType.indexOf(
                            'VENDOR'
                        ) < 0
                            ? 'hide'
                            : ''}"
                    >
                        <div class="panel panel--large panel--vendor">
                            <svg
                                width="48"
                                height="49"
                                viewBox="0 0 48 49"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <mask
                                    id="mask0_689_1671"
                                    style="mask-type:alpha"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="48"
                                    height="49"
                                >
                                    <rect
                                        y="0.5"
                                        width="48"
                                        height="48"
                                        fill="#D9D9D9"
                                    />
                                </mask>
                                <g mask="url(#mask0_689_1671)">
                                    <path
                                        d="M27.5028 25.9234C26.1055 25.9234 24.9228 25.4394 23.9548 24.4714C22.9868 23.5034 22.5028 22.3208 22.5028 20.9234C22.5028 19.5261 22.9868 18.3434 23.9548 17.3754C24.9228 16.4074 26.1055 15.9234 27.5028 15.9234C28.9001 15.9234 30.0828 16.4074 31.0508 17.3754C32.0188 18.3434 32.5028 19.5261 32.5028 20.9234C32.5028 22.3208 32.0188 23.5034 31.0508 24.4714C30.0828 25.4394 28.9001 25.9234 27.5028 25.9234ZM10.6953 32.1159V9.73145H44.3103V32.1159H10.6953ZM17.3103 29.1159H37.6953C37.6953 28.1186 38.0493 27.2666 38.7573 26.5599C39.4653 25.8536 40.3163 25.5004 41.3103 25.5004V16.3464C40.313 16.3464 39.4611 15.9924 38.7548 15.2844C38.0485 14.5764 37.6953 13.7254H17.3103C17.3103 13.7288 16.9563 14.5806 16.2483 15.2869C15.5403 15.9933 14.6893 16.3464 13.6953 16.3464V25.5004C14.6926 25.5004 15.5445 25.8544 16.2508 26.5624C16.9571 27.2704 17.3103 28.1216 17.3103 29.1159ZM3.69531 39.1159V15.6929H6.69531V36.1159H38.3488V39.1159H3.69531Z"
                                        fill="#1C1B1F"
                                    />
                                </g>
                            </svg>

                            <h1>
                                {$store.requestedServices.deliveryType ===
                                'SUCURSAL'
                                    ? 'Deberás realizar el pago directamente en sucursal para recibir tu kit de autoinstalación.'
                                    : 'Deberás realizar el pago directamente al técnico después de la instalación de tu servicio.'}
                            </h1>
                            <h2>
                                ¡Gracias por elegir izzi! Estamos para servirte.
                            </h2>
                        </div>
                    </div>
                {/if}
                {#if shouldShowPaypalPayment}
                    <div
                        id="tab_paypal"
                        class="payment-tab-content payment-tab-content--active {$store.purchaseStatus.paymentType.indexOf(
                            'PAYPAL'
                        ) < 0 && shouldShowPaypalPayment
                            ? 'hide'
                            : ''}"
                    >
                        <div class="panel m-b-40">
                            <p id="divPagoPayPal" class="fw-semibold m-b-15">
                                Paga con PayPal
                            </p>
                            {#if !$store.requestedServices.isSpMovil}
                                <p
                                    class="fw-semibold primary-text text-center"
                                    class:blue-dark-text={$store
                                        .requestedServices.isSky}
                                >
                                    Obtén ${monthlyPaymentAmount} de descuento adicional,
                                    al domiciliar.
                                </p>
                            {/if}
                            {#if $store.purchaseStatus.paypalStatus != 'COMPLETED'}
                                <div class="pure-g">
                                    <div class="pure-u-3-4">
                                        <p class="m-b-15">
                                            ¡Activar pago recurrente!
                                        </p>
                                    </div>
                                    <div class="pure-u-1-4 text-right">
                                        <span class="checkbox-switch">
                                            <input
                                                bind:checked={
                                                    monthlyPaymentPaypal
                                                }
                                                on:change={makeMonthlyPaymentPaypal}
                                                disabled={shouldBeDisabled}
                                                type="checkbox"
                                                name="pago_recurrente_paypal"
                                                id="pago_recurrente_paypal"
                                            />
                                            <label
                                                for="pago_recurrente_paypal"
                                            />
                                        </span>
                                    </div>
                                </div>
                            {/if}
                            <hr class="m-b-40" />
                            {#if monthlyPaymentPaypal}
                                <p class="m-b-0">
                                    Acepto el cargo recurrente en mi pago y las
                                    condiciones de uso del servicio
                                </p>
                            {/if}
                            {#if (monthlyPaymentPaypal && overridePayment) || $store.requestedServices.isSpMovil}
                                <div class="m-t-10" style="text-align: left;">
                                    <span style="font-size: smaller;"
                                        ><b>Se realizará un cargo de $1.00</b
                                        ></span
                                    >
                                </div>
                            {/if}
                            {#await fetchingPaymentPayPal}
                                <div class="pure-g">
                                    <div class="pure-u-1">
                                        <div class="text-center">
                                            <Preloader />
                                        </div>
                                    </div>
                                </div>
                            {:then response}
                                <div
                                    id="paypal-button-container"
                                    hidden={$store.purchaseStatus
                                        .paypalStatus == 'COMPLETED'}
                                ></div>
                                {#if $store.purchaseStatus.paypalStatus == 'COMPLETED'}
                                    <div
                                        class="alert alert--success alert--with-icon"
                                    >
                                        <svg class="icon" aria-hidden="true"
                                            ><use
                                                xlink:href="/assets/img/icons/symbol-defs.svg#icon-check-circle"
                                            /></svg
                                        >
                                        <p>Tu pago fue realizado con éxito.</p>
                                    </div>
                                {/if}
                            {/await}
                            {#if $store.purchaseStatus.paypalMessage}
                                <p id="mensajeResultadoPaypal" class="m-b-0">
                                    {$store.purchaseStatus.paypalMessage}
                                </p>
                            {/if}
                        </div>
                    </div>
                {/if}
            </div>
            <div class="payments-buttons">
                <button
                    on:click={valContent}
                    type="button"
                    disabled={!isMessageSent &&
                        $store.purchaseStatus.paymentType === 'ONLINE'}
                    class="pure__button continue-button"
                >
                    {buttonFinishText}
                </button>
            </div>
        </div>
    </div>
</div>
<Modal
    ident="modalError"
    title="Lo sentimos"
    message={messageInfoError}
    {customAction}
/>

<style>
    .hide {
        display: none;
    }
    input:disabled {
        background: #f5f6f8;
    }
    .loader {
        background-color: transparent;
        border: 2px solid #f3f3f3;
        border-top: 2px solid #d31772;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        display: inline-block;
        animation: spin 0.8s linear infinite;
        vertical-align: middle;
        position: relative;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
